import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CasepaperComponent} from './casepaper.component';


const routes: Routes = [
  {
    path: 'caserpaper/:visit_id', component: CasepaperComponent
  },{
    path: 'caserpaper/:visit_id/:bsId', component: CasepaperComponent
  }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/casepaper/casepaper.routing.ts